/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    current: {
      description: 'When the current item is selected',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    isChild: {
      description: 'when the item is child of another child',
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: false, hover: true, pressed: false },
      tokens: {
        groupBackgroundColor: '#efefef',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        itemBackgroundColor: '#efefef'
      }
    },
    {
      if: { focus: true, pressed: false },
      tokens: {
        groupBorderColor: '#7a3dfc',
        groupColor: '#7a3dfc',
        itemBorderBottomColor: '#7a3dfc',
        itemBorderLeftColor: '#7a3dfc',
        itemBorderRightColor: '#7a3dfc',
        itemBorderTopColor: '#7a3dfc'
      }
    },
    {
      if: { current: true },
      tokens: {
        groupBackgroundColor: '#000000',
        groupBorderColor: '#000000',
        groupColor: '#ffffff',
        itemBackgroundColor: '#000000',
        itemColor: '#ffffff'
      }
    },
    {
      if: { current: true, pressed: true },
      tokens: { itemBackgroundColor: '#b5b4b4', itemColor: '#595959' }
    },
    {
      if: { isChild: true },
      tokens: {
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#000000',
        itemBorderLeftWidth: 4,
        itemBorderTopWidth: 1
      }
    },
    {
      if: { isChild: true, pressed: true },
      tokens: {
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#595959',
        itemBorderTopWidth: 1,
        itemColor: '#595959'
      }
    },
    {
      if: { expanded: true },
      tokens: {
        groupBackgroundColor: 'rgba(0, 0, 0, 0)',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        groupColor: '#ffffff',
        groupIcon: PaletteIconChevronUp,
        itemColor: '#595959'
      }
    },
    {
      if: { current: true, isChild: true },
      tokens: {
        itemBackgroundColor: '#000000',
        itemBorderLeftColor: '#000000',
        itemColor: '#ffffff'
      }
    },
    {
      if: { current: true, focus: false, hover: true },
      tokens: {
        itemBackgroundColor: '#efefef',
        itemBorderLeftColor: '#efefef',
        itemColor: '#666666'
      }
    },
    {
      if: { current: true, focus: true, hover: true },
      tokens: {
        itemBackgroundColor: '#ffffff',
        itemBorderLeftColor: '#7a3dfc'
      }
    },
    {
      if: { focus: true, isChild: true },
      tokens: {
        itemBackgroundColor: '#ffffff',
        itemBorderBottomColor: '#7a3dfc',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#7a3dfc',
        itemBorderRightColor: '#7a3dfc',
        itemBorderRightWidth: 1,
        itemBorderTopColor: '#7a3dfc',
        itemBorderTopWidth: 1,
        itemColor: '#666666'
      }
    },
    {
      if: { hover: true, isChild: true },
      tokens: {
        itemBackgroundColor: '#efefef',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#666666',
        itemBorderRightWidth: 1,
        itemBorderTopWidth: 1,
        itemColor: '#666666'
      }
    },
    {
      if: { current: true, expanded: true, focus: true },
      tokens: {
        groupBackgroundColor: '#000000',
        groupBorderColor: '#7a3dfc',
        itemBorderLeftColor: '#7a3dfc',
        itemColor: '#666666'
      }
    },
    {
      if: { current: true, expanded: true, hover: true },
      tokens: {
        groupBackgroundColor: '#efefef',
        groupColor: '#666666',
        itemBackgroundColor: '#efefef',
        itemColor: '#666666'
      }
    },
    {
      if: { focus: true },
      tokens: {
        groupBackgroundColor: '#ffffff',
        groupBorderColor: '#7a3dfc',
        groupColor: '#666666',
        itemBackgroundColor: '#ffffff',
        itemBorderBottomColor: '#7a3dfc',
        itemBorderLeftColor: '#7a3dfc',
        itemBorderRightColor: '#7a3dfc',
        itemBorderTopColor: '#7a3dfc',
        itemColor: '#666666'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        groupBackgroundColor: '#404040',
        groupColor: '#666666',
        itemBackgroundColor: '#404040',
        itemBorderLeftColor: '#404040',
        itemColor: '#666666'
      }
    }
  ],
  tokens: {
    groupBackgroundColor: 'rgba(0, 0, 0, 0)',
    groupBorderColor: 'rgba(0, 0, 0, 0)',
    groupBorderRadius: 0,
    groupBorderWidth: 1,
    groupColor: '#666666',
    groupFontName: 'StagSans',
    groupFontSize: 16,
    groupFontWeight: '400',
    groupHeight: 32,
    groupIcon: PaletteIconChevronDown,
    groupPaddingBottom: 12,
    groupPaddingLeft: 16,
    groupPaddingRight: 16,
    groupPaddingTop: 12,
    itemBackgroundColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomWidth: 1,
    itemBorderLeftColor: 'rgba(0, 0, 0, 0)',
    itemBorderLeftWidth: 1,
    itemBorderRadius: 0,
    itemBorderRightColor: 'rgba(0, 0, 0, 0)',
    itemBorderRightWidth: 1,
    itemBorderTopColor: 'rgba(0, 0, 0, 0)',
    itemBorderTopWidth: 1,
    itemBorderWidth: 0,
    itemColor: '#666666',
    itemDisplay: false,
    itemFontName: 'StagSans',
    itemFontSize: 16,
    itemFontWeight: '400',
    itemHeight: 32,
    itemOutline: 0,
    itemPaddingBottom: 8,
    itemPaddingLeft: 16,
    itemPaddingRight: 16,
    itemPaddingTop: 8,
    itemTextDecoration: 'none',
    lineHeight: 1.5,
    minHeight: '100%',
    minWidth: '100%',
    shadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.2)',
      inset: false,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    }
  }
}
export default theme
